<template>
  <div>
    <mf-button :label="btnText" :disabled="loggedIn" @click="openWindow" />
  </div>
</template>

<script>
export default {
  name: 'GoogleLoginButton',
  props: {
    clientId: {
      type: String,
      required: true,
    },
    scopes: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  data: () => ({
    loggedIn: false,
    redirectUri: 'https://new-cdn.mercafacil.com/oauth-redirect.html',
  }),
  computed: {
    authUrl() {
      const clientId = this.clientId
      const redirectUri = encodeURIComponent(this.redirectUri)
      const state = encodeURIComponent(JSON.stringify({ originUrl: window.location.origin }))
      const scope = encodeURIComponent(this.scopes.join(' '))
      const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&state=${state}&access_type=offline&prompt=consent`
      return authUrl
    },
    btnText() {
      if (!this.loggedIn) {
        return 'Logar com GMail'
      } else {
        return 'GMail logado'
      }
    },
  },
  created() {
    window.addEventListener('message', this.handleAuthCode, false)
  },

  beforeDestroy() {
    window.removeEventListener('message', this.handleAuthCode, false)
  },
  methods: {
    openWindow() {
      window.open(this.authUrl, 'GoogleAuthWindow', 'width=500,height=600')
    },
    handleAuthCode(message) {
      if (message.data?.code) {
        this.loggedIn = true
        this.$emit('onSuccess', { authCode: message.data.code, redirectUri: this.redirectUri })
      }
    },
  },
}
</script>
